export default __webpack_public_path__ + "2d2ba0e5b8a3d0e007eb1abcb869f262.png";